export enum SocketIOEventEnum {
  // Base events
  CONNECTION = 'connection',
  DISCONNECT = 'disconnect',
  CONNECT = 'connect',
  NET_PING_DEVICE_GET_BARRIER_STATUS = 'net-ping-device:get-barrier-status',
  // Comment events
  COMMENT_ADD = 'comment:add',
  COMMENT_DELETE = 'comment:delete',
  COMMENT_RESTORE = 'comment:restore',
  COMMENT_EDIT = 'comment:edit',
  COMMENT_PARTIAL_EDIT = 'comment:partial-edit',
  COMMENT_LIST = 'comment:list',
  COMMENT_SEARCH = 'comment:search',
  COMMENT_STATUS = 'comment:status',
  COMMENT_TOGGLE_FAVORITE = 'comment:toggle-favorite',
  // Thread events
  THREAD_USERS_MENTION_LIST = 'thread:users-mention-list',
  THREAD_USERS_MENTION_LIST_UPDATED = 'thread:users-mention-list-updated',
  // Notification events
  NOTIFICATION_NEW = 'notification:new',
  NOTIFICATION_READ = 'notification:read',
  NOTIFICATION_LIST = 'notification:list',
  NOTIFICATION_COUNT = 'notification:count',
  // Project events
  PROJECT_UPDATED = 'project:updated',
  // BRS task events
  BRS_TASK_UPDATED = 'brs-task:updated',
  // Budget request events
  BUDGET_REQUEST_UPDATED = 'budget-request:updated',
  // Deal events
  DEAL_UPDATED = 'deal:updated',
  // Deal events
  DEALS_GROUP_UPDATED = 'deals-group:updated',
  // HelpDesk task events
  HELPDESK_TASK_UPDATED = 'helpdesk-task:updated',
  // Iron Logic Control events (photo-verification report)
  EQUIPMENT_LOG_PHOTO_VERIFICATION_LIST = 'equipment-log-photo-verification:list',
  EQUIPMENT_LOG_PHOTO_VERIFICATION_UPDATED = 'equipment-log-photo-verification:updated',
  // RTSP player events
  RTSP_PLAYER_CONNECT_TO_STREAM = 'rtsp-player:connect-to-stream',
  RTSP_PLAYER_DISCONNECT_FROM_STREAM = 'rtsp-player:disconnect-from-stream',
  RTSP_PLAYER_NEXT_FRAME = 'rtsp-player:next-frame',
  RTSP_PLAYER_STREAM_ERROR = 'rtsp-player:stream-error',
  // "CCTV" module events
  CCTV_EVENT_REPORT_GET_REPORT = 'cctv-event-report:get-report',
  CCTV_EVENT_REPORT_NEW_EVENT = 'cctv-event-report:new-event',
  // Telemetry events
  TELEMETRY_PAGE_HIT = 'telemetry:page-hit',
}
